import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTableViewComponent } from './user-table-view/user-table-view.component';
import { UserDetailViewComponent } from './user-detail-view/user-detail-view.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UserPasswordChangeComponent } from './user-password-change/user-password-change.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [
    UserTableViewComponent,
    UserDetailViewComponent,
    UserPasswordChangeComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    MatListModule,
    MatGridListModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSortModule,
  ],
})
export class UserModule {}
